import { useEffect, useState } from "react";
import { CoverageDiagnosis } from "../../components";
import { useChopinQuestion } from "../../hooks";
import type { InterventionProps, Vertical } from "../../types";

type IntentPopupProps = {
  vertical: Vertical;
} & InterventionProps;

export const IntentCoverageDiagnosisIntervention = (
  props: IntentPopupProps,
) => {
  const { answer: intent } = useChopinQuestion("what_are_you_here_to_do");
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(intent == "find_what_insurance_needed");
  }, [intent, setShow]);

  return show ? <CoverageDiagnosis {...props} initialShow={true} /> : null;
};
